import React from 'react';
import { Props } from '../InlineView';
import cn from 'classnames';
import DumbView from '../../../DeviationViews/Dumbo/EditorDumbo';
import PriceWithPoints from '../../../ShopCard/_partials/PriceWithPoints';
import { getDeviationPrice } from '../../../utils/deviations';
import { formatDollars } from '../../../utils/formatting';
import Flex from '@wix/da-ds/pkg/Flex';
import UserAvatar from '../../../User/Avatar/UserAvatar';
import UserLink from '../../../User/Link/UserLink';

import s from './Commission.scss';

const CommissionInlineView: React.FC<Props> = props => {
  const { deviation, width, height } = props;
  const { dollarsPrice, pointsPrice } = getDeviationPrice(deviation);
  const { title, author } = deviation;

  return (
    <div className={cn(s['root'])} style={{ width }}>
      <DumbView
        className={s['thumb']}
        width={width - 2}
        height={height}
        deviation={deviation}
      />
      <div>
        <Flex direction="column" className={s['details']}>
          <Flex direction="row" alignItems="stretch">
            <div className={s['left-cell']}>
              <div className={s['avatar']}>
                <UserAvatar user={author} size={28} />
              </div>
            </div>
            <div className={cn(s['two-center-cells'])}>
              <div className={s['title']}>{title}</div>
              {author && (
                <div className={s['username']}>
                  {<UserLink user={author} />}
                </div>
              )}
            </div>
            <div className={s['right-cell']}>
              <PriceWithPoints
                formattedDollarsPrice={formatDollars(dollarsPrice)}
                pointsPrice={pointsPrice}
              />
            </div>
          </Flex>
        </Flex>
      </div>
    </div>
  );
};
CommissionInlineView.displayName = 'CommissionInlineView';

export default CommissionInlineView;
